
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SplitDepositSettingFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SplitDepositSettings"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allocations"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SmartDepositAllocationFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isActive"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isHidden"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SplitDepositDirectDepositSettingFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SplitDepositDirectDepositSetting"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SplitDepositSettingFragment"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isUsingRecommendedAllocations"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"awaitingConfiguration"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isActive"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isHidden"},"arguments":[],"directives":[]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SplitDepositIntentSettingFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SplitDepositDirectDepositIntentSetting"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SplitDepositSettingFragment"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isUsingRecommendedAllocations"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"estimatedPaycheckAmount"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isActive"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isHidden"},"arguments":[],"directives":[]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SmartDepositAllocationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SplitDepositDirectDepositAllocation"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allocationPercent"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"targetAccountId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"targetAccountType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nickname"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"normalizedAmount"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"},"arguments":[],"directives":[]}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SplitDepositFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SplitDeposit"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"distributedAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"expectedNextDepositAmount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"expectedNextDepositAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isActive"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isCancelable"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isUsingRecommendedAllocations"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"transactionAmount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"willDistributeAutomaticallyAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"allocations"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SmartDepositAllocationFragment"},"directives":[]}]}}]}}],"loc":{"start":0,"end":1084}};
    doc.loc.source = {"body":"fragment SplitDepositSettingFragment on SplitDepositSettings {\n  allocations {\n    ...SmartDepositAllocationFragment\n  }\n  id\n  isActive\n  isHidden\n  name\n}\n\nfragment SplitDepositDirectDepositSettingFragment on SplitDepositDirectDepositSetting {\n  ...SplitDepositSettingFragment\n  isUsingRecommendedAllocations\n  awaitingConfiguration\n  name\n  isActive\n  isHidden\n}\n\nfragment SplitDepositIntentSettingFragment on SplitDepositDirectDepositIntentSetting {\n  ...SplitDepositSettingFragment\n  isUsingRecommendedAllocations\n  estimatedPaycheckAmount {\n    value\n  }\n  name\n  isActive\n  isHidden\n}\n\nfragment SmartDepositAllocationFragment on SplitDepositDirectDepositAllocation {\n  allocationPercent\n  targetAccountId\n  targetAccountType\n  nickname\n  normalizedAmount {\n    value\n  }\n}\n\nfragment SplitDepositFragment on SplitDeposit {\n  createdAt\n  distributedAt\n  expectedNextDepositAmount\n  expectedNextDepositAt\n  id\n  isActive\n  isCancelable\n  isUsingRecommendedAllocations\n  transactionAmount\n  willDistributeAutomaticallyAt\n  allocations {\n    ...SmartDepositAllocationFragment\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["SplitDepositSettingFragment"] = oneQuery(doc, "SplitDepositSettingFragment");
        
        module.exports["SplitDepositDirectDepositSettingFragment"] = oneQuery(doc, "SplitDepositDirectDepositSettingFragment");
        
        module.exports["SplitDepositIntentSettingFragment"] = oneQuery(doc, "SplitDepositIntentSettingFragment");
        
        module.exports["SmartDepositAllocationFragment"] = oneQuery(doc, "SmartDepositAllocationFragment");
        
        module.exports["SplitDepositFragment"] = oneQuery(doc, "SplitDepositFragment");
        
